import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { BranchesModalBranch } from '../../components/BranchesModalBranch/BranchesModalBranch';
import branchesModalStore from '../../store/branchesModalStore';
import { Icons } from '~/assets/fonts/Icons/icons';
import theme from '~/constants/styles';
import { localeStore } from '~/mobx/localesStore';
import { IBranch } from '~/types/branches';
import { emptyArray } from '~/utils/helpers';
import Icon from '~/view/components/Controls/Icon/Icon';

export const BranchesModalBranches: FC = observer((): ReactElement => {
  const { loading, isNoBranchesForRender, pagination } = branchesModalStore;

  if (loading) {
    return (
      <>
        {emptyArray().map((item, index) => (
          <BranchesModalBranch key={index} />
        ))}
      </>
    );
  }

  if (isNoBranchesForRender) {
    return (
      <div className="d-flex flex-column full-height full-width align-items-center justify-content-center">
        <Icon name={Icons.BranchesTree} color={theme.colors.gray} size={150} className="mb-6" />
        <p className="family-medium text-size-24 color-gray2">{localeStore.t('branches_not_found')}</p>
      </div>
    );
  }

  return (
    <>
      {pagination.data.map((branch: IBranch) => (
        <BranchesModalBranch key={branch.id} branch={branch} />
      ))}
    </>
  );
});
